import clsx from "clsx";

export const ListItemPlaceholder = (props: { size?: number }) => {
    const { size = 5 } = props;

    return (
        <div className="placeholder-glow">
            <span className={clsx("placeholder bg-white w-100", `py-${size}`)}></span>
        </div>
    );
};

export const ListPlaceholder = () => (
    <div className="vstack gap-2">
        <ListItemPlaceholder />
        <ListItemPlaceholder />
        <ListItemPlaceholder />
    </div>
);
